import { render, staticRenderFns } from "./GridInvocation.vue?vue&type=template&id=5637813c&scoped=true"
import script from "./GridInvocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridInvocation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridInvocation.vue?vue&type=style&index=0&id=5637813c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637813c",
  null
  
)

export default component.exports